import React, { useEffect, useRef, useState } from "react";
import Header from "../../Components/Header";
import { useNavigate } from "react-router-dom";
import { leftArrow } from "../../common/Assets/imgs";
import { FaSearch } from "react-icons/fa";
import MaterialTable from "../../Components/Table/MaterialTable";
import { get } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";

const UserTransactions = () => {

  const navigation = useNavigate();
  const [search, setSearch] = useState("");
  const [pagination, setPagination] = useState(1);
  const [totalCount, setTotalCount] = useState(1);
  const [loader, setLoader] = useState(false);
  //  const adminList = [
  //         {
  //             sno: "01",
  //             adminId: "KD075821",
  //             adminName: "Vikram",
  //             role: "Admin",
  //             mobile: "+91 8965346856",
  //             status: "Active",
  //             DateTime:"10-12-2025,1:00 PM",
  //             amount:"3500",
  //             payment:"Advance",
  //         },
  //         {
  //             sno: "02",
  //             adminId: "KD075822",
  //             adminName: "Surya",
  //             role: "Super Admin",
  //             mobile: "+91 8965346856",
  //             status: "Active",
  //             DateTime:"10-12-2025,1:00 PM",
  //             amount:"3500",
  //             payment:"Full Amount",
  //         },
  //         {
  //             sno: "03",
  //             adminId: "KD075823",
  //             adminName: "Ajay",
  //             role: "Sub Admin",
  //             mobile: "+91 8965346856",
  //             status: "De-Active",
  //             DateTime:"10-12-2025,1:00 PM",
  //             amount:"3500",
  //             payment:"Advance",
  //         },
  //     ];

  const [adminList, setAdminList] = useState([]);
  const pageSize = 10;
  const columns = [
    {
      // accessorKey: "sno",
      header: "S.No",
           accessorFn: (row, index) =>
    (pagination - 1) * pageSize + index + 1,
    //   accessorFn: (row, index) => index + 1,
      id: "serial_no",
    },
    {
      accessorKey: "ride_id",
      header: "Ride ID",
    },
    {
      accessorKey: "user_name",
      header: "User Name",
    },
    {
      accessorKey: "amount",
      header: "Amount",
    },
    {
      accessorKey: "date_time",
      header: "Date & Time",
    },
    {
      accessorKey: "payment_type",
      header: "Payment Type",
      Cell: ({ cell }) => {
        const value = cell.getValue();

        return (
          <span
            className="text-center "
            style={{
              color: value === "Advance" ? "#007bff" : "#28a745",
              fontWeight: 500,
            }}
          >
            {value}
          </span>
        );
      },
    },


  ];

  const getList = async (src, page) => {
    try {
      setLoader(true);
      const res = await get(`${URLS.USER_TRANSACTIONS_LIST}?search=${src}&page=${page}`);
      console.log("res", res);
      setAdminList(res?.data);
      setTotalCount(res?.count);
      setLoader(false);
    } catch (err) {
      console.log("err", err);
      setLoader(false);
    }
  };

  useEffect(() => {
    const delay = setTimeout(() => {
      getList(search, pagination);
    }, 500)

    return () => clearTimeout(delay);
  }, [search, pagination]);
  // ✅ RESET PAGE when searching
  useEffect(() => {
    setPagination(1);
  }, [search]);

  return (
    <div>
      <Header title={"Transaction Management"} />

      <div className="container-fluid main-container">
        <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
          {/* LEFT TITLE */}
          {/* Header */}
          <div onClick={() => navigation(-1)} className="admin-header mb-0">
            {/* <img src={leftArrow} className="back-icon-arrow" /> */}
            <h2>User Transaction</h2>
          </div>
          {/* <h3 className="m-0 fw-bold fs-5 text-black">Transaction Management</h3> */}

          {/* RIGHT SECTION */}
          <div className="d-flex align-items-center gap-3">
            {/* SEARCH BOX */}
            <div className="search-box d-flex align-items-center px-3">
              <input
                type="text"
                placeholder="Search"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className="border-0 outline-none bg-transparent"
              />
              <div className="ms-2 searchdote">|</div>
              <FaSearch color="#7A52AB" className="ms-1" />
            </div>
          </div>
        </div>

        <MaterialTable columns={columns}
          rowCount={totalCount}
          data={adminList || []}
          pagination={pagination}
          setPagination={setPagination}
          loading={loader}
        />
      </div>
    </div>
  );
};

export default UserTransactions;
